import * as React from "react";
import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

export function ProgressIndicator({ value = 0, size = 32 }) {
  return (
    <Box sx={{ position: "relative", display: "inline-flex" }}>
      <CircularProgress
        size={size}
        variant="determinate"
        value={value}
        thickness={5}
        sx={{
          color: value >= 80 ? "success.main" : value >= 40 ? "warning.main" : "primary.main",
        }}
      />
      <Box
        sx={{
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          position: "absolute",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Typography
          fontSize={size > 28 ? 9 : 7}
          variant="caption"
          component="div"
          color="text.secondary"
          fontWeight={600}
        >
          {`${Math.round(value)}%`}
        </Typography>
      </Box>
    </Box>
  );
}

export default function ProjectProgress({ value }) {
  const [progress, setProgress] = React.useState(10);

  React.useEffect(() => {
    if (value !== undefined) return;
    const timer = setInterval(() => {
      setProgress((prev) => (prev >= 100 ? 0 : prev + 10));
    }, 800);
    return () => clearInterval(timer);
  }, [value]);

  if (value !== undefined) {
    return <ProgressIndicator value={value} />;
  }

  return <ProgressIndicator value={progress} />;
}
